import { ServiceData } from '@/types';

import articles from './YOGA_ARTICLES_DK.json';
import exercises from './YOGA_EXERCISES_DK.json';
import recipes from './YOGA_RECIPES_DK.json';

export const YOGA_DATA_DK: ServiceData = {
  articles,
  exercises,
  recipes,
};
